import { patientHandlers } from './patient.handler';
import { paymentConfigHandlers } from './paymentConfig.handler';
import { paymentSubmissionsHandlers } from './paymentSubmissions.handler';

export const handlers = [
  ...patientHandlers,
  ...paymentConfigHandlers,
  ...paymentSubmissionsHandlers,
];
